import React from "react";
import { NewsDetailData } from "../../../pages/NewsDetail/types";
import { NewsDetailImage } from "./NewsDetailImage";
import { NewsDetailHeader } from "./NewsDetailHeader";
import { NewsDetailContent } from "./NewsDetailContent";
import { SwiperNavigationButtons } from "./SwiperNavigationButtons";

interface NewsDetailDesktopProps {
  newsData: NewsDetailData;
  scrolled: boolean;
  showLeftButton: boolean;
  showRightButton: boolean;
  onScrollPrev: () => void;
  onScrollNext: () => void;
}

export const NewsDetailDesktop: React.FC<NewsDetailDesktopProps> = ({
  newsData,
  showLeftButton,
  showRightButton,
  onScrollPrev,
  onScrollNext,
}) => {
  return (
    <div
      className="flex flex-col gap-[2px] px-6 bg-[#F2F4FB]"
    >
      <div className="relative bg-white max-w-[1392px] w-full gap-3 p-4 m-auto">
        {/* News Content */}
        <div className="flex flex-col w-full max-w-[698px] gap-3">
          {/* News Image */}
          <NewsDetailImage newsData={newsData} />

          {/* Source, Headline, Timestamp, Stock ticker */}
          <NewsDetailHeader newsData={newsData} />

          {/* Article Body */}
          <NewsDetailContent newsData={newsData} />
        </div>

        {/* Swiper Navigation Buttons */}
        <SwiperNavigationButtons
          showLeftButton={showLeftButton}
          showRightButton={showRightButton}
          onScrollPrev={onScrollPrev}
          onScrollNext={onScrollNext}
          isMobile={false}
          headline={newsData.headline}
          componentPosition="1"
        />
      </div>
    </div>
  );
};

